import { useTranslation } from "react-i18next";
import Badge from "@cloudscape-design/components/badge";
import SpaceBetween from "@cloudscape-design/components/space-between";

function ScenarioHeader({ scenario }) {
  const { t } = useTranslation();
  if (!scenario) return null;

  const getDirectionBadgeColor = (direction) => {
    switch (direction) {
      case "inbound": return "blue";
      case "outbound": return "green";
      default: return "grey";
    }
  };

  const getVisibilityBadgeColor = (visibility) => visibility === "public" ? "blue" : "grey";
  const getStatusBadgeColor = (status) => status === "published" ? "green" : "grey";

  return (
    <header className="scenario-header">
      <div className="scenario-header-image">
        {scenario.image_url ? (
          <img src={scenario.image_url} alt="" />
        ) : (
          <div className="scenario-header-image-placeholder">{t("scenarios.tile.no_image")}</div>
        )}
      </div>
      <div className="scenario-header-content">
        <div className="scenario-header-title">
          <h2>{scenario.name}</h2>
          <SpaceBetween direction="horizontal" size="xxs">
            <Badge color={getDirectionBadgeColor(scenario.call_direction)}>{t(`scenarios.call_direction.${scenario.call_direction}`)}</Badge>
            {scenario.visibility && (
              <Badge color={getVisibilityBadgeColor(scenario.visibility)}>
                {t(`scenarios.visibility.${scenario.visibility}`)}
              </Badge>
            )}
            {scenario.status && (
              <Badge color={getStatusBadgeColor(scenario.status)}>
                {t(`scenarios.status.${scenario.status}`)}
              </Badge>
            )}
          </SpaceBetween>
        </div>
        <p className="scenario-header-description">{scenario.description}</p>
      </div>
    </header>
  );
}

export default ScenarioHeader;
